/* eslint-disable */
// @ts-nocheck
import { reducerWrapper } from '../support/utils';
import { LOADING_STATUS } from '../support/constants';
import { CREATE_USER_API_KEY, RESET_USER_API_KEY, GET_USER_API_KEYS } from '../actions/AuthServiceActions';
import { AuthServiceReducer } from '../types/authServiceTypes';
const INIT_STATE: AuthServiceReducer = {
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  oldUserApiKey: null,
  currentUserApiKey: null,
};

const Handler = (
  state: AuthServiceReducer,
  action: {
    type: string;
    data: any;
  }
) => {
  const { data } = action;

  switch (action.type) {
    case CREATE_USER_API_KEY.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
        currentUserApiKey: data,
      });

    case GET_USER_API_KEYS.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
        currentUserApiKey: data.new_key,
        oldUserApiKey: data.old_key,
      });

    case RESET_USER_API_KEY.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
        currentUserApiKey: data.new_key,
        oldUserApiKey: data.old_key,
      });

    default:
      return state;
  }
};

export default reducerWrapper(INIT_STATE, Handler, {
  request: [CREATE_USER_API_KEY, RESET_USER_API_KEY, GET_USER_API_KEYS],
  error: [CREATE_USER_API_KEY, RESET_USER_API_KEY, GET_USER_API_KEYS],
  resetOn: ['APP_CHANGE'],
});
